import { useContext } from 'react'
import WebDataContext from '../context/WebDataProvider';

const useWebData = () => {
    return useContext(WebDataContext);
}

export default useWebData